
import React, { useEffect, useState } from "react";
import {
    CalendarOutlined,
    ClockCircleOutlined,
    UserOutlined,
    ArrowRightOutlined,
    ArrowLeftOutlined,
} from "@ant-design/icons";

import moment from "moment";

import {
    calculateWaitMinutes,
    calculateWaitMinutesRealtime,
    calculateCompleteTimeText,
    isValidDate,
    formatTimeWithH,
    ConvertCustomerScheduleType,
} from "@/utils/helpers";

const ScheduleTimeCell = ({ record }) => {
    const [currentTime, setCurrentTime] = useState(moment()); // tự xử lý

    // Cập nhật mỗi 1 phút
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(moment());
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    const time = record.time;
    const appointmentTime = record.time_to;
    const startChairTime = record.start_time;
    const completedAt = record.completed_at;
    const appointmentName = record.name;

    const waitText = calculateWaitMinutes(appointmentTime, startChairTime);
    const waitTextRealtime = calculateWaitMinutesRealtime(appointmentTime, currentTime);
    const completeText = calculateCompleteTimeText(startChairTime, completedAt);

    return (
        <div style={{ lineHeight: "1.2em" }}>
            {time && (
                <>
                    <div style={{ color: "#006179", fontWeight: 500 }}>
                        <CalendarOutlined style={{ marginRight: 6 }} />
                        {isValidDate(record.time, false)}
                    </div>

                    <div style={{ color: "#1890ff", fontWeight: 500 }}>
                        <ClockCircleOutlined style={{ marginRight: 6 }} />
                        {formatTimeWithH(time)}
                        <span style={{ fontSize: 12, color: "#666" }}>
                            {" "}({ConvertCustomerScheduleType(record.name)})
                        </span>
                    </div>
                </>
            )}

            {appointmentTime && (
                <div style={{ color: "#52c41a", fontWeight: 500 }}>
                    <UserOutlined style={{ marginRight: 6 }} />
                    {formatTimeWithH(appointmentTime)}
                    <span style={{ fontSize: 12, color: "#666" }}> (Đến)</span>
                </div>
            )}

            {(appointmentName === "LAMDICHVU" || appointmentName === "TAIKHAM") && (
                <>
                    {startChairTime && (
                        <div style={{ color: "#faad14", fontWeight: 500 }}>
                            <ArrowRightOutlined style={{ marginRight: 6 }} />
                            {formatTimeWithH(startChairTime)}
                            {waitText && (
                                <span style={{ color: "#999", fontSize: 12, marginLeft: 4 }}>
                                    {waitText}
                                </span>
                            )}
                        </div>
                    )}

                    {!startChairTime && waitTextRealtime && (
                        <div style={{ color: "#faad14", fontWeight: 500, fontSize: 13 }}>
                            <ArrowRightOutlined style={{ marginRight: 6 }} />
                            {waitTextRealtime}
                        </div>
                    )}

                    {completedAt && (
                        <div style={{ color: "#13c2c2", fontWeight: 500 }}>
                            <ArrowLeftOutlined style={{ marginRight: 6 }} />
                            {formatTimeWithH(completedAt)}
                            {completeText && (
                                <span style={{ color: "#999", fontSize: 12, marginLeft: 4 }}>
                                    {completeText}
                                </span>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ScheduleTimeCell;
